<template>
	<div>
		<Layout :navFixed="true" :transparent="true">
			<div class="container" v-if="item">
				<div class="row">
					<div class="col py-3 mt-3">
						<router-link :to="`/`" class="btn btn-light btn-sm shadow-bottom ">
							<i class="icon icon-left-open-big"></i>
							<span>Volver</span>
						</router-link>
					</div>
				</div>
				<div class="row row-xs">
					<div class="col-12 col-md-8">
						<div class="card card-event shadow-bottom mb-4">
							<div class="card-body">
								<EventData :eventId="item.id" />
							</div>
						</div>

						<div class="mb-3">
							<MembershipBanner :eventId="item.id" />
						</div>

						<div class="card shadow-bottom mb-3">
							<div class="card-body">
								<div class="p-3">
									<h5>Acerca de este evento</h5>
									<div class="mt-2" v-html="item.description"></div>

									<h6 class="mt-3">Condiciones de cancelacion o devolucion</h6>
									<div>
										asdasdasdsad
									</div>
								</div>
							</div>
						</div>

						<div class="card shadow-bottom mb-3">
							<div class="card-body">
								<div class="p-3">
									Eventos similares y/o del mismo productor
								</div>
							</div>
						</div>
					</div>

					<div class="col-12 col-md-4">
						<div class="card shadow-bottom mt-3 mb-3">
							<div class="card-body">
								<EventBuyTickets :eventId="item.id" :eventCode="item.code" />
							</div>
						</div>

						<div class="card shadow-bottom mb-3">
							<div class="card-body">
								<div class="label">Ubicación</div>
								<div class="map" v-if="mapUrl">
									<img :src="mapUrl" class="img-fluid" />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</Layout>
	</div>
</template>

<script>
import gql from "graphql-tag"
import Layout from "@/components/Layout"
import EventBuyTickets from "./EventBuyTickets"
import MembershipBanner from "@/views/account/MembershipBanner"
import EventData from "@/views/events/EventData"

export default {
	name: "Home",
	components: {
		Layout,
		EventBuyTickets,
		EventData,
		MembershipBanner
	},
	data() {
		return {
			loading: false,
			item: null,
			mapUrl: null
		}
	},

	async beforeMount() {
		await this.load()
		this.mapUrl = `https://maps.googleapis.com/maps/api/staticmap?center=${this.item.location.latlng.lat},${this.item.location.latlng.lng}&zoom=15&size=340x300&maptype=roadmap&markers=${this.item.location.latlng.lat},${this.item.location.latlng.lng}&key=${process.env.VUE_APP_GOOGLE_API_KEY}`

		if (this.$route.query.ref) this.$store.commit("savePromotorCode", this.$route.query.ref)
	},

	methods: {
		load() {
			this.loading = true
			return this.$apollo
				.query({
					query: gql`
						query($code: String!) {
							event(code: $code) {
								id
								code
								account {
									id
								}
								name
								startAt
								endAt
								description
								minAge
								image {
									id
									type
									filename
									url
									urlThumb
								}
								location {
									id
									name
									locality {
										name
										region {
											name
										}
									}
									address
									latlng {
										lat
										lng
									}
								}

								status
								statusText
								statusClass
							}
						}
					`,
					variables: {
						code: this.$route.params.code
					},
					fetchPolicy: "no-cache"
				})
				.then(({ data }) => {
					this.loading = false
					this.item = data.event
					return true
				})
		}
	}
}
</script>

<style scoped lang="scss">
.card-event {
	padding: 0px;
	margin-top: 14px;
	margin-bottom: 14px;

	.card-body {
		display: flex;
		padding: 0px;
	}
	& /deep/ .event-data .image {
		width: 228px;
		height: 228px;

		border-radius: 8px;
		margin: -8px 18px -8px 0px;
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
	}
}

.map img {
	border-radius: 6px;
}
h5 {
	font-size: 1.1rem;
}
</style>
